module.exports = __webpack_public_path__ + "static/media/PRACTICA2.60717972.png";